import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_486: DocMigration = {
  maxSchemaVersion: "0.0.486",
  description: "Store asset aspect ratio in inline image annotations",
  apply(json: any): any {
    const { annotation = {} } = json;
    for (const annotationId in annotation) {
      const annot = annotation[annotationId];
      if (annot.type === "DETAIL" && annot.detailType === "INLINE_IMAGE") {
        if (annot.height > 0) {
          // 1e6 is here just as a fallback in case the image width/height have somehow been corrupted.
          annot.assetAspectRatio = Math.min(1e6, Math.abs(annot.width / annot.height));
        } else {
          // Image dimensions have been lost when the image was scaled to zero size.
          // Use a default value that will prevent division by zero, but that's not necessarily correct.
          annot.assetAspectRatio = 1;
        }
      }
    }
    json.annotation = annotation;
    return json;
  },
};

export default migration_0_0_486;
